import React from 'react'

import {css} from '../../theme/css'
import {createSvgIcon} from '../utils'

const root = css`
  block-size: 32px;
  inline-size: 162px;
  mask-type: alpha;
`

export default createSvgIcon(
  <>
    <g clipPath="url(#clip0_17002_1439)">
      <g clipPath="url(#clip1_17002_1439)">
        <mask
          height="29"
          id="mask0_17002_1439"
          maskUnits="userSpaceOnUse"
          width="28"
          x="0"
          y="2"
        >
          <circle cx="14" cy="16.5" fill="white" r="14" />
        </mask>
        <g mask="url(#mask0_17002_1439)">
          <rect
            fill="#FC3F1D"
            height="28"
            transform="translate(0 2.5)"
            width="28"
          />
          <path
            d="M16.0644 10.3405H14.6476C12.2186 10.3405 11.0042 11.555 11.0042 13.3767C11.0042 15.4008 11.8138 16.4128 13.6355 17.6273L15.0524 18.6393L11.0042 24.914H7.76562L11.6114 19.2465C9.3849 17.6273 8.17044 16.2104 8.17044 13.5791C8.17044 10.3405 10.3969 8.11401 14.6476 8.11401H18.8982V24.914H16.0644V10.3405Z"
            fill="white"
          />
        </g>
      </g>
      <g clipPath="url(#clip2_17002_1439)">
        <rect
          fill="#5C5A57"
          fillOpacity="0.1"
          height="28"
          rx="14"
          width="28"
          x="32"
          y="2.5"
        />
        <g clipPath="url(#clip3_17002_1439)">
          <path
            d="M31.0195 8.73007L43.2695 4.32007L55.5195 8.73007V24.4101L43.2695 28.8201L31.0195 24.4101V8.73007Z"
            fill="#FF7751"
          />
          <path
            d="M31.0195 8.72998L43.2695 13.14V28.82L31.0195 24.41V8.72998Z"
            fill="#E13100"
          />
          <path
            d="M55.5195 8.72998L43.2695 13.14V28.82L55.5195 24.41V8.72998Z"
            fill="#FC4714"
          />
          <path
            d="M54.1719 21.6008C51.5419 24.1485 47.3232 25.6052 44.6172 25.0784V23.7004C47.2687 24.2412 51.5228 22.9195 54.1719 20.2219V21.6008ZM48.7432 17.5764L47.874 17.8928V21.5901L45.7031 22.3801V18.6829L44.834 18.9993L46.7881 13.6663L48.7432 17.5764ZM53.9541 15.6799L53.0859 15.9954V19.6926L50.9141 20.4836V16.7864L50.0459 17.1018L52 11.7688L53.9541 15.6799Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d="M67.0166 29.2068V25.5H75.9385V29.2068H78.8273V23.097H77.1656V7.73282H66.8121L66.5564 15.0442C66.4286 19.2623 66.0963 21.742 65.2782 23.097H64.1278V29.2068H67.0166ZM69.2662 15.4532L69.4452 10.1359H74.0723V23.097H68.1925C68.7294 21.8699 69.1384 19.6713 69.2662 15.4532ZM85.3963 12.3855C82.0474 12.3855 79.721 14.763 79.721 19.0834C79.721 23.3782 82.0474 25.7556 85.3963 25.7556C88.7452 25.7556 91.0716 23.3782 91.0716 19.0578C91.0716 14.763 88.7452 12.3855 85.3963 12.3855ZM85.3963 23.3526C83.7091 23.3526 82.8654 22.0488 82.8654 19.0834C82.8654 16.0923 83.7091 14.7886 85.3963 14.7886C87.0836 14.7886 87.9272 16.0923 87.9272 19.0578C87.9272 22.0488 87.0836 23.3526 85.3963 23.3526ZM98.6362 25.7556C100.042 25.7556 101.039 25.5 101.781 24.9631V22.4834C101.014 23.0203 100.093 23.3526 98.8152 23.3526C96.6422 23.3526 95.7475 21.6654 95.7475 19.0067C95.7475 16.2202 96.8467 14.7886 98.8407 14.7886C100.017 14.7886 101.167 15.1976 101.781 15.5811V12.9991C101.142 12.6412 100.017 12.3855 98.5084 12.3855C94.6226 12.3855 92.603 15.172 92.603 19.0834C92.603 23.3782 94.5715 25.7556 98.6362 25.7556ZM113.133 15.0442V12.6412H102.933V15.0442H106.512V25.5H109.554V15.0442H113.133ZM123.772 16.7314C123.772 13.6126 122.187 12.4366 118.966 12.4366C116.946 12.4366 115.361 13.0758 114.441 13.6126V16.1435C115.259 15.5299 117.049 14.8653 118.608 14.8653C120.065 14.8653 120.73 15.3765 120.73 16.757V17.4728H120.244C115.592 17.4728 113.521 19.0067 113.521 21.6142C113.521 24.2218 115.106 25.679 117.458 25.679C119.247 25.679 120.014 25.091 120.602 24.4774H120.73C120.756 24.8098 120.858 25.2444 120.96 25.5H123.925C123.823 24.4519 123.772 23.4037 123.772 22.3556V16.7314ZM120.73 22.4323C120.346 22.9947 119.631 23.4549 118.557 23.4549C117.279 23.4549 116.64 22.6879 116.64 21.5375C116.64 20.0292 117.688 19.4924 120.295 19.4924H120.73V22.4323ZM131.28 25.5C134.296 25.5 136.086 24.2218 136.086 21.7676C136.086 20.0804 135.063 19.1089 133.351 18.8022C134.731 18.4187 135.6 17.4472 135.6 15.9134C135.6 13.7149 134.143 12.6412 131.331 12.6412H126.218V25.5H131.28ZM130.896 14.9419C131.996 14.9419 132.609 15.4021 132.609 16.3735C132.609 17.2683 131.944 17.8051 130.794 17.8051H129.26V14.9419H130.896ZM130.947 20.0292C132.251 20.0292 132.942 20.4894 132.942 21.5631C132.942 22.7391 132.175 23.1992 130.947 23.1992H129.26V20.0292H130.947ZM145.668 25.5H149.119L144.236 18.5721L148.531 12.6412H145.463L141.169 18.5721V12.6412H138.126V25.5H141.169V19.1856L145.668 25.5ZM159.472 16.7314C159.472 13.6126 157.887 12.4366 154.666 12.4366C152.647 12.4366 151.062 13.0758 150.141 13.6126V16.1435C150.959 15.5299 152.749 14.8653 154.308 14.8653C155.765 14.8653 156.43 15.3765 156.43 16.757V17.4728H155.944C151.292 17.4728 149.221 19.0067 149.221 21.6142C149.221 24.2218 150.806 25.679 153.158 25.679C154.947 25.679 155.714 25.091 156.302 24.4774H156.43C156.456 24.8098 156.558 25.2444 156.66 25.5H159.626C159.523 24.4519 159.472 23.4037 159.472 22.3556V16.7314ZM156.43 22.4323C156.047 22.9947 155.331 23.4549 154.257 23.4549C152.979 23.4549 152.34 22.6879 152.34 21.5375C152.34 20.0292 153.388 19.4924 155.996 19.4924H156.43V22.4323Z"
        fill="#21201F"
      />
    </g>
    <defs>
      <clipPath id="clip0_17002_1439">
        <rect fill="white" height="32" width="162" />
      </clipPath>
      <clipPath id="clip1_17002_1439">
        <rect
          fill="white"
          height="28"
          transform="translate(0 2.5)"
          width="28"
        />
      </clipPath>
      <clipPath id="clip2_17002_1439">
        <rect fill="white" height="28" rx="14" width="28" x="32" y="2.5" />
      </clipPath>
      <clipPath id="clip3_17002_1439">
        <rect
          fill="white"
          height="24.5"
          transform="translate(31.0195 4.32007)"
          width="24.5"
        />
      </clipPath>
    </defs>
  </>,
  'DostavkaLogoWithBoxExpanded',
  {className: root, viewBox: '0 0 162 32'},
)
